<div id="headerSection" [hidden]="showHeader==false" class="top-header white border-b">
  <span class="brand-logo" *ngIf="!loginservice.isHideGebbsLogo && !showCurranceLogo()">
    <img src="assets/images/logo_156.png" class="logo-img">
  </span>
  <span class="brand-logo" *ngIf="isCurrance && showCurranceLogo()">
    <img src="assets/images/Currance_headerlogo.png" class="logo-img">
  </span>

  <span class="text-center page-title grey-text">
    <img *ngIf="isCiiNRALogo" src="assets/images/CiiNRA_logo.png" alt="CiiNRA logo" style="margin-top: -16px;">
    <b>{{title}}</b>
    <span *ngIf="activeReasonBucket && activeReasonBucket.length>0">({{activeReasonBucket}})</span></span>
      <span *ngIf="instructionCount > 0" class="text-center page-marquee">
        <marquee behavior="" direction="">
          <b class="red">Attention</b> : There is an update. Kindly check the client instruction screen.
        </marquee>
      </span>

  <div class="utilitySection">
    <!-- https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQLwb629K3S0fWbkdTSQCnE7YacNQLGrm_X6w&usqp=CAU  OLD-->
    <!-- https://cdn.pixabay.com/photo/2014/03/25/16/54/button-297546_640.png NEW -->
    <!-- <div [ngClass]="{'disabled': clientInstructionRestriction == true}" *ngIf="route && route.url=='/agent/agent' && isMyInbox" class="priorityBtn" title="Inbox" (click)="openInboxModal()">
      <div class="text btn-default">
        i-Agent
        <i style="background: transparent;color:#fff" *ngIf="projectListStatus==true"
          class="fa fa-refresh fa-spin"></i>
      </div>
    </div> -->

    <!-- <div [ngClass]="{'disabled': clientInstructionRestriction == true}" *ngIf="route && route.url=='/agent/agent' && isMyInbox" class="priorityBtn" title="Project & Priority"
      (click)="openProjectAndPriorityModal()">
      <div class="text btn-default">
        Project & Priorities
        <div class="count" style="height: auto;">
          <i style="background: transparent;color:#fff" *ngIf="projectListStatus==true"
            class="fa fa-refresh fa-spin"></i>
          <span *ngIf="projectListStatus==false">
            {{projectList.length || 0}}
          </span>
        </div>
      </div>
    </div> -->

    <span class="" style="right: 5%;">
       <i class="fa fa-user fa-2x" style="background: none;margin: 0;font-size: 22px;"></i><span class="b-600"
       style="bottom: 3px;position: relative;right: 0;">{{UserData.Full_Name}}</span>
    </span>

    <img (click)="Logout()" title="Log Out" src="assets/images/log-out.png" alt="">
    <!-- <i (click)="Logout()" title="Log Out" class="fa fa-power-off fa-2x" style="margin: 0 1rem" aria-hidden="true"></i> -->
    <!-- <i (click)="hideHeader()" title="Full Screen" class="fa fa-window-maximize fa-2x" aria-hidden="true"></i> -->

  </div>
</div>

<!-- <div class="exitMessage"> -->
<div class="exitMessage" *ngIf="showExitMessage==true">
  <p>Press <span style="border: 1px solid #fff;">Esc</span> to Exit full screen</p>
</div>
